<template>
  <div class="_cont">
    <h3 class="formHead">BCT商务汉语考试</h3>
    <van-form @submit="onSubmit"
              ref="formName">
      <van-field v-model="form.cert_name"
                 name="证件姓名"
                 label="证件姓名"
                 placeholder="证件姓名"
                 required
                 :rules="[{ required: true, message: '请输入证件姓名' }]" />
      <van-field v-model="form.cn_name"
                 name="中文姓名"
                 label="中文姓名"
                 placeholder="中文姓名"
                 required
                 :rules="[{ required: true, message: '请输入中文姓名' }]" />
      <van-field v-model="form.country"
                 name="国籍"
                 label="国籍"
                 placeholder="国籍"
                 required
                 :rules="[{ required: true, message: '请输入国籍' }]" />
      <van-field name="radio"
                 label="性别"
                 required>
        <template #input>
          <van-radio-group v-model="form.gender"
                           direction="horizontal">
            <van-radio name="男">男</van-radio>
            <van-radio name="女">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field readonly
                 clickable
                 name="datetimePicker"
                 :value="form.birth_date"
                 label="出生日期"
                 placeholder="出生日期"
                 @click="showPicker2 = true"
                 required
                 :rules="[{ required: true, message: '请选择出生日期' }]" />
      <van-field v-model="form.first_language"
                 name="第一语言"
                 label="第一语言"
                 placeholder="第一语言" />
      <van-field v-model="form.first_language_code"
                 name="第一语言"
                 label="第一语言"
                 placeholder="第一语言" />
      <van-field readonly
                 clickable
                 name="picker"
                 :value="cert_type_lable"
                 label="证件类型"
                 placeholder="select the ID type"
                 required
                 :rules="[{ required: true, message: '请选择证件类型' }]"
                 @click="showPicker = true" />
      <van-field v-model="form.cert_code"
                 name="证件编号"
                 label="证件编号"
                 placeholder="证件编号"
                 required
                 :rules="[{ required: true, message: '请输入证件编号' }]" />
      <van-field v-model="form.phone"
                 name="联系电话"
                 label="联系电话"
                 placeholder="联系电话"
                 :rules="[{ required: true, message: '请输入联系电话' }]" />

      <van-field v-model="form.email"
                 name="Email"
                 label="Email"
                 placeholder="Email"
                 required
                 :rules="[{ required: true, message: '请输入E-mail' }]" />
      <van-field v-model="form.address"
                 name="通信地址"
                 label="通信地址"
                 placeholder="通信地址"
                 required
                 :rules="[{ required: true, message: '请输入通信地址' }]" />
      <van-field v-model="form.post_code"
                 name="邮编"
                 label="邮编"
                 placeholder="邮编" />
      <van-field v-model="form.year"
                 name="学习汉语年限"
                 label="学习汉语年限"
                 placeholder="学习汉语年限" />
      <van-field name="form.subject"
                 label="报考科目"
                 required
                 :rules="[{ required: true, message: '请选择报考科目' }]">
        <template #input>
          <van-checkbox-group v-model="form.subject"
                              direction="horizontal">
            <van-checkbox name="BCT（A）"
                          shape="square">BCT（A）</van-checkbox>
            <van-checkbox name="BCT（B）"
                          shape="square">BCT（B）</van-checkbox>
            <van-checkbox name="BCT（听·读）（Listening·Reading）"
                          shape="square">BCT（听·读）（Listening·Reading）</van-checkbox>
            <van-checkbox name="BCT（说·写）（Speaking·Writing）"
                          shape="square">BCT（说·写）（Speaking·Writing）</van-checkbox>
            <van-checkbox name="BCT（听·读）+ BCT（说·写）（Both）"
                          shape="square">BCT（听·读）+ BCT（说·写）（Both）</van-checkbox>
            <van-checkbox name="BCT（Listening·Reading）+ BCT（Speaking·Writing）"
                          shape="square">BCT（Listening·Reading）+ BCT（Speaking·Writing）</van-checkbox>
          </van-checkbox-group>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round
                    block
                    type="info"
                    native-type="submit">Submit</van-button>
      </div>
    </van-form>
    <van-popup v-model="showPicker"
               position="bottom">
      <van-picker show-toolbar
                  :columns="cert_types"
                  @confirm="onConfirm"
                  @cancel="showPicker = false" />
    </van-popup>
    <van-popup v-model="showPicker2"
               position="bottom">
      <van-datetime-picker type="date"
                           :min-date="minDate"
                           :max-date="maxDate"
                           @confirm="onConfirm2"
                           @cancel="showPicker2 = false" />
    </van-popup>
  </div>
</template>

<script>
import axiosApi from "../api/api.js";
import { Toast } from 'vant';
export default ({
  name: 'Form-bm',
  props: {
    formTitle: {
      type: String,
      default: ''
    },
    typeId: {
      type: Number,
    },
  },
  data () {
    return {
      form: {
        cert_name: '',
        cn_name: '',
        country: '',
        gender: '男',
        birth_date: '',
        first_language: '',
        first_language_code: '',
        cert_type: '',
        cert_code: '',
        phone: '',
        email: '',
        address: '',
        post_code: '',
        year: '',
        subject: [],
      },
      cert_type_lable: '',
      cert_types: [{ text: 'Passport', value: '护照' }, { text: 'ID Card', value: '身份证' }],
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(),
      showPicker: false,
      showPicker2: false,

    }
  },
  methods: {
    onSubmit () {
      axiosApi('message', {
        form_type: 3,
        ...this.form
      }, 'post').then(res => {
        if (res.data.status) {
          Toast.success('success')
          this.form = {
            cert_name: '',
            cn_name: '',
            country: '',
            gender: '男',
            birth_date: '',
            first_language: '',
            first_language_code: '',
            cert_type: '',
            cert_code: '',
            phone: '',
            email: '',
            address: '',
            post_code: '',
            year: '',
            subject: [],
          }
          this.$emit('hideForm');
          this.$refs.formName.resetValidation();
        } else {
          Toast.fail('error')
        }
      })
    },
    clearForm () {
      this.$refs.formName.resetValidation();
      this.form = {
        cert_name: '',
        cn_name: '',
        country: '',
        gender: '男',
        birth_date: '',
        first_language: '',
        first_language_code: '',
        cert_type: '',
        cert_code: '',
        phone: '',
        email: '',
        address: '',
        post_code: '',
        year: '',
        subject: [],
      }
    },
    onConfirm (value) {
      this.showPicker = false
      this.form.cert_type = value.value
      this.cert_type_lable = value.text
    },
    onConfirm2 (time) {
      this.showPicker2 = false
      this.form.birth_date = time
    },
  },
})
</script>

<style lang="scss" scoped>
.formHead {
  text-align: center;
  font-size: 36px;
  margin-bottom: 20px;
}
._cont {
  padding: 20px 0;
}
.van-checkbox--horizontal {
  margin-bottom: 20px;
}
</style>